import { ConfirmDelete } from "components/ConfirmDialog/ConfirmDelete";
import { ConfirmDeleteTarget } from "models/ConfirmDeleteTarget";
import { useApi, useTask, useToasts, useTranslations } from "providers";
import { useMeeting } from "providers";
import { useCallback } from "react";

export const ConfirmDeleteTask: React.FC = () => {
  const i18n = useTranslations();
  const toasts = useToasts();
  const { reloadMeeting } = useMeeting();
  const { tasksApi } = useApi();
  const { confirmDeleteTask, setConfirmDeleteTask, setTaskDeleting } = useTask();

  const isOpen = confirmDeleteTask !== undefined;

  const handleDelete = useCallback(
    async (target?: ConfirmDeleteTarget) => {
      if (!target) return;

      setConfirmDeleteTask(undefined);
      setTaskDeleting(target.id, true);
      try {
        await tasksApi.delete(target.id);
      } catch (error) {
        toasts.deleteFailure(i18n.Task, target.title, error);
      } finally {
        reloadMeeting().finally(() => {
          setTaskDeleting(target.id, false);
        });
      }
    },
    [tasksApi, reloadMeeting, setTaskDeleting, setConfirmDeleteTask, i18n, toasts]
  );

  const setIsOpen = useCallback(
    (open: boolean) => {
      if (!open) {
        setConfirmDeleteTask(undefined);
      }
    },
    [setConfirmDeleteTask]
  );

  return (
    <ConfirmDelete
      content={i18n.Actions_Delete_Task_Confirm}
      title={i18n.Actions_Delete_Task_Title}
      entityName={i18n.Task}
      entityTitle={confirmDeleteTask?.title}
      onAccept={() => handleDelete(confirmDeleteTask)}
      onCancel={() => setConfirmDeleteTask(undefined)}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};
